// Event bus
// http://lostechies.com/derickbailey/2012/04/03/revisiting-the-backbone-event-aggregator-lessons-learned/
import _ from 'underscore';
import Backbone from 'backbone';

export default _.extend({}, Backbone.Events, {cid: 'dispatcher'});
